import { useState } from 'react';
import ValentinesImage from '../../images/valentine-poster.jpeg';


function PhoneNumber() {
  const [phone, setPhone] = useState(null);
  
  const loadPhone = () => {
    // Could even fetch from API if you want extra protection
    setPhone(getPhone());
  };

  const getPhone = () => ['929', '724', '4234'].join('-');
  
  return phone ? (
    <a href={`tel:+1${phone.replace(/-/g, '')}`}>{phone}</a>
  ) : (
    <span onClick={loadPhone} style={{cursor: 'pointer', textDecoration: 'underline'}}>
      [click for phone number]
    </span>
  );
}

export default function ValentinesSite() {
    const style = {
        color: 'black',
        backgroundColor: '#F6F6FF',
        height: '100vh',
        fontFamily: 'Times New Roman, serif',
        padding: '20px',
        overflow: 'scroll',
    };

    return (
        <div style={style}>
            <h1 style={{ margin: 0 }}>Nett Valentine's at Rubulad </h1>
            <p>
                <b>Sunday, February 15, 2026</b>
                <br />
                <i>389 Melrose St, Brooklyn, NY 11237</i>
                <br />
                <i>Doors at 7, Show at 8</i>
            </p>

            <div
                style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: '20px',
                    gap: '20px',
                    flexWrap: 'wrap',
                }}
            >
                <img
                    src={ValentinesImage}
                    alt="Valentine's Poster"
                    style={{
                        width: '400px',
                        height: 'auto',
                        marginBottom: 0,
                        flexShrink: 0,
                        borderRadius: '8px',
                    }}
                />

                <div style={{ flex: 1, minWidth: '300px' }}>
                    <p>

                        Celebrate Valentine's Day weekend at Rubulad with Pink St. and friends. Live music from Brooklyn bands Nett, Cowboygirl, and Myra Lee (FKA Dino Expedition). Flash tattoos by Kaelan Brown (<a href="https://www.instagram.com/guttaboyswag/">@guttaboyswag</a>). Art John (<a href="https://www.instagram.com/lejohnno/">@lejohnno</a>) and Malu (<a href="https://www.instagram.com/claudi.malu/">@claudi.malu</a>).
                    </p>

                    <iframe
                        style={{ border: 0, width: '100%', height: '42px' }}
                        src="https://bandcamp.com/EmbeddedPlayer/track=4282717451/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/"
                        seamless
                    >
                        <a href="https://nettnyc.bandcamp.com/track/spare-parts">
                            Spare Parts by Nett
                        </a>
                    </iframe>

                    <p>
                        <iframe width="400" height="300" src="https://www.youtube.com/embed/rW90q_cJqlE?si=-Tag6nBJfY6GgM0c" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </p>

                </div>
            </div>
            <section>
                <h2>Hotline</h2>

                <p>
                    <i>Call {PhoneNumber()} and leave us a voicemail. Confess your secret crush and we'll invite them to the show anonymously.</i>  
                   
                </p>
                <audio src="/audio/greeting.m4a" controls></audio>
            </section>
            <section>
                <h2>Tickets</h2>
                <p>
                    Tickets will be available at the door and can be purchased in advanced <a href="https://withfriends.events/event/rDb6fdC3/valentines-hotline">here</a>.
                </p>
            </section>
            <p>
                <br />~
                <br />~
                <br />~
                <br />~
                <br />~

            </p>
        </div>
    );
}
